export enum MaritalStatusEnum {
  single = 'SOLTEIRO',
  married = 'CASADO',
  widower = 'VIUVO',
  divorced = 'DIVORCIADO',
  separate = 'SEPARADO',
  stableUnion = 'UNIAO ESTAVEL'
}
